import type { ReactNode } from 'react';

export interface EmptyProps {
  title?: ReactNode;
  description?: ReactNode;
  action?: ReactNode;
}

export function Empty({ title = '暂无数据', description, action }: EmptyProps) {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '48px 16px',
        color: '#8c8c8c',
        textAlign: 'center',
        gap: 8,
      }}
    >
      <div style={{ fontSize: 48, opacity: 0.4 }} aria-hidden>
        ∅
      </div>
      <div style={{ fontSize: 14, fontWeight: 500 }}>{title}</div>
      {description ? <div style={{ fontSize: 12 }}>{description}</div> : null}
      {action ? <div style={{ marginTop: 12 }}>{action}</div> : null}
    </div>
  );
}
